import { TextTemplate } from '@onoranzefunebricloud/giotto-text-template';
import { onErrorShowMessage } from '../../errors';
import { fetchQuotes } from '../../~graphql/controllers';
import _ from 'lodash';
import { getTextTemplateContext } from '../../utils';

export const fetchEditorQuotes = async (forceFetch = false) => {
  const hasCache = _.has(window.editorConfig, 'sidebarQuotes.items');

  if (hasCache && !forceFetch) {
    return {
      quotes: {
        allowNew: false,
        items: window.editorConfig.sidebarQuotes.items,
      },
    };
  }

  try {
    let quotes = await fetchQuotes();

    const {
      servizio,
      user,
      deleganti,
      necrofori,
      card,
      serviceReservation,
    } = await getTextTemplateContext();

    const textTemplate = new TextTemplate(
      servizio,
      user,
      deleganti,
      necrofori,
      card,
      serviceReservation
    );

    quotes = quotes.map((quote) => {
      if (!quote.category) {
        quote.category = 'dedica';
      }
      quote.testo = textTemplate.renderMustache(quote.testo);
      return quote;
    });

    let items = [];

    items = [...quotes];

    items.sort((i1, i2) => {
      if (i1.isGlobal) {
        return 1;
      } else if (!i1.isGlobal && i2.isGlobal) {
        return -1;
      } else {
        return 0;
      }
    });

    return {
      quotes: {
        allowNew: true,
        items,
      },
    };
  } catch (errors) {
    console.error(errors);
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Errore',
      text: `C'è stato un errore nel caricamento dei testi. Prova a ricaricare e, se l'errore persiste, contatta l'assistenza fornendo questo codice: ${errors}`,
      confirmButtonColor: '#278e8e',
    });
  }
};
